* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: 30px 0 0 20px;
}

.im-policy-form-section {
  width: 100%;
  height: auto;
  display: flex;
  margin-top: var(--spacer);
  align-items: flex-start;
  flex-direction: column;
  gz-input {
    margin-left: calc(var(--spacer) * 2);
    width: 400px;
  }
  gz-input-error {
    margin-left: calc(var(--spacer) * 1.2);
  }

  gzTitle {
    padding: calc(var(--spacer) * 2.12) 0 calc(var(--spacer) * 2.12) 0;
    color: var(--black-layout-700-primary);
    opacity: 0.5;
  }

  #im-realtime-mode-title {
    margin-top: 32px;
  }

  #im-realtime-rule-processing-mode-title {
    margin-top: 32px;
    margin-bottom: 16px;
  }

  #im-realtime-mode {
    //margin-top: 23px;
    display: none;
  }

  #policy-rule-sets-section-labeled-content {
    //margin-top: 8px;
    margin-top: 16px;
  }
}

integrity-monitor-policy-rule-sets-section {
  margin-left: calc(var(--spacer) * 2);
}
